/** Session keys — must match Angular AuthService keys */
export const YARDI_INVITE_LIST_SESSION_KEY = 'yardiinvitelist_filter'
export const YARDI_SEARCH_GUEST_SESSION_KEY = 'yardisearchguest_filter'

export const YARDI_STATUS_MAPPING: Record<string, string> = {
  PROCESSED: 'Processed',
  PROCESSING: 'Processing',
  FAILED: 'Failed',
  INQUEUE: 'In Queue',
  INVITE_SENT: 'Invite Sent',
}

export const YARDI_INVITE_LIST_DEFAULTS = {
  page: 1,
  perPage: 15,
  sortBy: 'desc' as const,
  orderBy: 'yardi_application_id',
}

export const PER_PAGE_OPTIONS = [15, 30, 50, 100] as const

/** Occupants sub-table: Prospect ID is short; Angular uses equal ~10% cols — keep ID narrower. */
export const APPLICANT_COL_WIDTHS_PCT = [8, 11, 14, 11, 12, 14, 15, 15] as const

/** Guest search occupant sub-table (8 columns). */
export const GUEST_CARD_OCCUPANT_COL_WIDTHS_PCT = [10, 10, 14, 14, 12, 14, 10, 10] as const

export const YARDI_INVITE_COL_WIDTHS_PCT = [2, 5, 10, 10, 8, 10, 7, 9, 19, 8, 5, 7] as const

/** Guest search main table: expand | dates x3 | credit check | unit | duration | status | action */
export const YARDI_GUEST_SEARCH_COL_WIDTHS_PCT = [2, 9, 9, 9, 30, 8, 8, 11, 5] as const

/** Main prospect/name search: debounced auto-refresh (drawer company/property still use Done). */
export const MAIN_SEARCH_DEBOUNCE_MS = 400

export const PROPERTY_NAME_LINK_CLASS =
  'font-medium text-[rgb(21_151_255)] hover:text-[#0d7acc] hover:underline'

export const FILTER_TEXT_INPUT_CLASS =
  'w-full min-h-[40px] rounded-lg border border-slate-200 bg-slate-50 px-3 text-sm text-slate-900 shadow-sm transition-colors placeholder:text-slate-400 focus:border-[rgb(21_151_255)] focus:outline-none focus:ring-2 focus:ring-[rgb(21_151_255)]/15 hover:bg-white hover:border-slate-300'

export const GUEST_ALLOWED_ROLES = ['ROLE_ADMIN', 'ROLE_CUSTOMER_SERVICE', 'ROLE_CUSTOMER_SERVICE_MANAGER']

export const INITIAL_URL_PARAMS: Record<string, string | boolean> = {
  q: '',
  org_id: '',
  company_id: '',
  property_id: '',
  first_name: '',
  last_name: '',
  email_address: '',
  phone_number: '',
  date_of_birth: '',
  third_party_id: '',
  join_filter_items_with_and: true,
  federal_id: '',
}

/** Form-owned keys removed after a session snapshot so cleared fields don't leave stale request values. */
export const GUEST_SEARCH_SESSION_OVERLAY_KEYS = [
  'org_id',
  'org_name',
  'company_id',
  'company_name',
  'property_id',
  'property_name',
  'first_name',
  'last_name',
  'email_address',
  'phone_number',
  'date_of_birth',
  'third_party_id',
  'federal_id',
  'join_filter_items_with_and',
] as const

/** Optional guest-search fields beyond company/property. */
export const YARDI_GUEST_SEARCH_CRITERIA_KEYS = [
  'first_name',
  'last_name',
  'email_address',
  'phone_number',
  'date_of_birth',
  'third_party_id',
  'federal_id',
] as const

/** List filter query keys; stripped before re-apply so cleared fields win over session merge. */
export const LIST_FILTER_QUERY_KEYS = ['q', 'org_id', 'company_id', 'property_id'] as const

/** Session-only display keys stripped before building request params. */
export const YARDI_SESSION_META_KEYS = ['org_name', 'company_name', 'property_name'] as const

/** Only these keys belong on the list filter form; session also stores page, perPage, sortBy, orderBy, etc. */
export const YARDI_INVITE_LIST_FORM_KEYS = ['q', 'org_id', 'company_id', 'property_id'] as const

/** LR check error type → display label. */
export const LR_CHECK_ERROR_TYPE_LABELS: Record<string, string> = {
  LEASE_START_DATE_TOO_OLD: 'Invalid past lease start date',
}

/** Guest search: Angular `appService.notify(error, 0)` when `/api/search_guest_cards` lacks optional criteria. */
export const YARDI_GUEST_SEARCH_CRITERIA_MESSAGE =
  'At least one search filter (like name, email, phone, etc.) must be provided.'

/** Shown in guest invite modal when contact info must be fixed in Yardi. */
export const YARDI_GUEST_INVITE_CONTACT_INFO_MESSAGE =
  'Each applicant needs either an email address or a mobile phone number. This information is managed in Yardi and cannot be updated here.'

/** Angular payment.datahandler dateControl includes date_of_birth */
const DATE_CONTROL_KEYS = new Set<string>(['date_of_birth'])

const PHONE_KEYS = new Set<string>([
  'mobile_no',
  'supervisor_mobile_no',
  'landlord_mobile_no',
  'contact_phone',
  'company_phone',
  'agent_mobile_no',
  'org_phone',
  'company_office_phone',
  'property_office_phone',
  'phone_number',
])

const AMOUNT_KEYS = new Set<string>([])

export function isDateControlKey(key: string): boolean {
  return DATE_CONTROL_KEYS.has(key)
}

export function isPhoneKey(key: string): boolean {
  return PHONE_KEYS.has(key)
}

export function isAmountKey(key: string): boolean {
  return AMOUNT_KEYS.has(key)
}
